import { render } from "./BaseSpinner.vue?vue&type=template&id=975ae350&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=975ae350&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975ae350"]])

export default __exports__